import { render, staticRenderFns } from "./VaClientSideList.vue?vue&type=template&id=27a26081&scoped=true&"
import script from "./VaClientSideList.vue?vue&type=script&lang=js&"
export * from "./VaClientSideList.vue?vue&type=script&lang=js&"
import style0 from "./VaClientSideList.vue?vue&type=style&index=0&id=27a26081&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a26081",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VIcon,VSelect})
